





































































































































import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin'

export default BaseCmsBlock.extend({
  name: "CategoriesByTypeAndColorMenuBlock",
  data() {
    return {
      swiperOptions: {
        speed: 3000,
        slidesPerView: '2',
        centeredSlides: false,
        spaceBetween: 10,
        // autoplay: {
        //   delay: 5000,
        //   disableOnInteraction: false,
        //   waitForTransition: false,
        // },
        loop: true,
        loopedSlides: 1,
        navigation: {
          prevEl: '.swiper-btn-prev',
          nextEl: '.swiper-btn-next'
        },
        pagination: {
          el: ".categories-swiper-pagination",
          clickable: true,
          bulletElement: "div",
          dynamicMainBullets: 0,
        }
      }

    };
  },

  methods: {
    getLinkImage: function (imageId) {
      let sizes = {width: 1500, height: 450};

      if (!this.$isServer) {
        const innerWidth = window.innerWidth;

        if (innerWidth < 1200) {
          sizes = {width: 960, height: 300};
        }
        if (innerWidth < 600) {
          sizes = {width: 600, height: 180};
        }
        if (innerWidth < 400) {
          sizes = {width: 400, height: 150};
        }
      }

      return this.$img(imageId.toString(), sizes);
    }
  }
});
